export const isDevEnvironment =
  import.meta.env.DEV ||
  import.meta.env.SENTRY_ENV === 'development' ||
  import.meta.env.SENTRY_ENV === 'staging';

export const isAccessModalEnabled =
  import.meta.env.DEV || import.meta.env.VITE_ENABLE_ACCESS_MODAL === 'true';
